// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 69 ? "core_info" : chunkId) + "." + {"69":"efe76551","742":"0af43d91","939":"5e348ed4"}[chunkId] + ".js";
};